// Environment configuration utilities
export const env = {
  // API Configuration
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://api.diversae.com.py',
  API_VERSION: import.meta.env.VITE_API_VERSION || 'v1',
  
  // Google Maps
  GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
  
  // Google OAuth
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
  
  // Facebook OAuth
  FACEBOOK_APP_ID: import.meta.env.VITE_FACEBOOK_APP_ID || '',
  
  // Apple OAuth
  APPLE_CLIENT_ID: import.meta.env.VITE_APPLE_CLIENT_ID || '',
  
  // New Relic
  NEW_RELIC_LICENSE_KEY: import.meta.env.VITE_NEW_RELIC_LICENSE_KEY || '',
  NEW_RELIC_APPLICATION_ID: import.meta.env.VITE_NEW_RELIC_APPLICATION_ID || '',
  
  // App Configuration
  APP_NAME: import.meta.env.VITE_APP_NAME || 'Walabi',
  APP_DESCRIPTION: import.meta.env.VITE_APP_DESCRIPTION || 'E-commerce Platform',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
  
  // Environment
  NODE_ENV: import.meta.env.VITE_NODE_ENV || 'development',
  IS_DEVELOPMENT: import.meta.env.VITE_NODE_ENV === 'development',
  IS_PRODUCTION: import.meta.env.VITE_NODE_ENV === 'production',
  
  // Payment
  STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '',
  
  // WhatsApp
  WHATSAPP_NUMBER: import.meta.env.VITE_WHATSAPP_NUMBER || '595123456789',
  
  // Upload Configuration
  MAX_FILE_SIZE: parseInt(import.meta.env.VITE_MAX_FILE_SIZE || '5242880'), // 5MB
  ALLOWED_IMAGE_TYPES: (import.meta.env.VITE_ALLOWED_IMAGE_TYPES || 'image/jpeg,image/png,image/webp,image/gif').split(','),
  
  // Session Configuration
  SESSION_TIMEOUT: parseInt(import.meta.env.VITE_SESSION_TIMEOUT || '900000'), // 15 minutes
  REFRESH_TOKEN_TIMEOUT: parseInt(import.meta.env.VITE_REFRESH_TOKEN_TIMEOUT || '604800000'), // 7 days
  
  // Feature Flags
  ENABLE_GOOGLE_MAPS: import.meta.env.VITE_ENABLE_GOOGLE_MAPS === 'true',
  ENABLE_NEW_RELIC: import.meta.env.VITE_ENABLE_NEW_RELIC === 'true',
  ENABLE_PWA: import.meta.env.VITE_ENABLE_PWA === 'true',
  ENABLE_DARK_MODE: import.meta.env.VITE_ENABLE_DARK_MODE === 'true',
}

// Validation function to check required environment variables
export function validateEnvironment() {
  const required = [
    'VITE_API_BASE_URL',
  ]
  
  const missing = required.filter(key => !import.meta.env[key])
  
  if (missing.length > 0) {
    console.error('Missing required environment variables:', missing)
    throw new Error(`Missing required environment variables: ${missing.join(', ')}`)
  }
}

// Helper to get full API URL
export function getApiUrl(endpoint: string = '') {
  const baseUrl = `${env.API_BASE_URL}/api/${env.API_VERSION}`
  return endpoint ? `${baseUrl}/${endpoint.replace(/^\//, '')}` : baseUrl
}

// Helper to check if feature is enabled
export function isFeatureEnabled(feature: keyof typeof env): boolean {
  return Boolean(env[feature])
}
